import { render } from "./SimpleHeader.vue?vue&type=template&id=532be804&scoped=true"
import script from "./SimpleHeader.vue?vue&type=script&lang=js"
export * from "./SimpleHeader.vue?vue&type=script&lang=js"

import "./SimpleHeader.vue?vue&type=style&index=0&id=532be804&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532be804"]])

export default __exports__